var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-image__container"},[_c('img',{staticClass:"survey-image__image",class:{
      'survey-image__image--not-selected': !_vm.isSelected,
    },attrs:{"src":_vm.src,"alt":"image showing answer option, see label that appears when selected"},on:{"click":_vm.handleImageClick}}),(_vm.label)?_c('div',{staticClass:"survey-image__label",class:{
      'survey-image__label--show': _vm.isSelected,
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }